import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withKeys as _withKeys, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13b3e7cb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tit" }, "鹿小岚教务管理系统", -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("登 录")

import { reactive, ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { Avatar, Lock } from "@element-plus/icons-vue";
import { login, ssoLogin } from "../config/interface";
import { ElMessage } from "element-plus";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const logining = ref(false);
const labelPosition = ref("right");
const form = reactive({
  account: "",
  pwd: "",
});
const router = useRouter();
const handleLogin = () => {
  let param = {
    account: form.account,
    pwd: form.pwd,
  };
  logining.value = true;
  login(param).then((response) => {
    const res: any = response.data;
    if (res.errorCode === 200) {
      localStorage.setItem("ACCESS_TOKEN", JSON.stringify(res.data));
      router.push({ path: "/index" });
    } else {
      ElMessage.error(res.msg);
    }
    logining.value = false;
  });
};
const checkSso = () => {
  ssoLogin({}).then((res: any) => {
    console.log(res)
  })
};
// 生命周期以及 watch 书写
onMounted(() => {
  //..do some thing
  checkSso()
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_el_form, {
        "label-position": labelPosition.value,
        "label-width": "60px",
        model: _unref(form),
        style: {"max-width":"460px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, { label: "用户名:" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _unref(form).account,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).account) = $event)),
                placeholder: "请输入用户名",
                "suffix-icon": _unref(Avatar)
              }, null, 8, ["modelValue", "suffix-icon"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: '密   码:' }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _unref(form).pwd,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).pwd) = $event)),
                type: "password",
                placeholder: "请输入密码",
                "show-password": "",
                "suffix-icon": _unref(Lock),
                onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (handleLogin()), ["enter"]))
              }, null, 8, ["modelValue", "suffix-icon"])
            ]),
            _: 1
          }),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            type: "primary",
            style: {"width":"250px"},
            onClick: _cache[3] || (_cache[3] = ($event: any) => (handleLogin()))
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          })), [
            [_directive_loading, logining.value]
          ])
        ]),
        _: 1
      }, 8, ["label-position", "model"])
    ])
  ]))
}
}

})